import React, {Component} from 'react';
import {connect} from 'react-redux';
import Action from 'actions';
import Tooltip from 'components/atoms/tooltip';
import InputCheckbox from 'components/atoms/inputs/input-checkbox';

class ShowPlayersExposureWhileOptimized extends Component {
    onClick(isChecked) {
        this.props.dispatch(Action.set('ShowPlayersExposureWhileOptimized', isChecked));
    }

    render() {
        const {settings} = this.props;
        const isChecked = settings.isShowPlayersExposureWhileOptimizedUsed();

        return (
            <div>
                <div className="input-info top-info">
                    <Tooltip subject="Enable this checkbox if you prefer to see changing of players' exposures during lineups optimization process. This is only relevant for Browser side algorithm." />

                    <InputCheckbox
                        label="Show players exposure during optimization"
                        checked={isChecked}
                        onChange={::this.onClick}
                    />
                </div>
            </div>
        );
    }
}

function mapStatesToProps(state) {
    const {settings} = state.lineupGenerator;

    return {
        settings,
    };
}

export default connect(mapStatesToProps)(ShowPlayersExposureWhileOptimized);
